<template>
  <div class="content" style="background-color: #fff">
    <div v-if="onShow" class="phonelogin">
      <div class="recharge_body" style="padding: 1rem 0.4rem 8rem 0.4rem">
        <img src="../../assets/images/xsblogo.png" style="
            width: 75px;
            height: 75px;
            margin-left: 40%;
            margin-bottom: 27px;
          " />
        <div class="recharge_phone">
          <van-field v-model="phone" placeholder="请输入手机号" style="background-color: #f6f6f6; border-radius: 5px" />
        </div>
        <a href="javascript:void(0)" class="recharge3" @click="getOrganizationInfo" style="margin-top: 0.5rem; border-radius: 8px; width: 100%" :border="false">机构查询</a>
      </div>
    </div>
    <div v-if="!onShow" class="recharge_content">
      <van-tabs v-model="active" color="#3A89FF" title-active-color="#3A89FF" @change="getTab">
        <van-tab title="话费充值">
          <div class="recharge_head">
            <p style="margin: 0.4rem">
              <span>账号：<font v-text="organizationInfo.organizationName"></font></span>
              <van-popup v-model="show" position="bottom" round>
                <p v-for="item in actions" :key="item" class="recharge4" @click="
                    organizationInfo = item;
                    show = false;
                    
                  ">
                  <span v-text="item.organizationName"></span>
                </p>
              </van-popup>
            </p>
            <p style="margin: 0.3rem 0.4rem">当前余额：</p>
            <p>
              <span style="font-size: 0.32rem">￥</span>
              <strong style="font-size: 0.72rem; line-height: 0.72rem" v-text="organizationInfo.accountBalance / 100">00.00</strong>
            </p>
          </div>
          <div class="recharge_body">
            <div>
              <strong class="recharge1">充值</strong>
            </div>
            <div class="recharge_input">
              <label>￥</label>
              <input type="number" name="money" min="100" v-model="money" />
              <img src="../../assets/images/inputclear.png" @click="
                  money = '';
                  active = 0;
                " />
            </div>
          </div>
          <div class="recharge2">
            <span v-for="(item, index) in billMoneyList" :key="index" :class="money == item ? 'active' : ''" @click="money = item">{{ item }}元</span>
            <!-- <span :class="money==100?'active':''" @click="money=100;">100元</span>
				<span :class="money==200?'active':''" @click="money=200;">200元</span>
				<span :class="money==300?'active':''" @click="money=300;">300元</span>
				<span :class="money==500?'active':''" @click="money=500;">500元</span>
				<span :class="money==1000?'active':''" @click="money=1000;">1000元</span>
				<span :class="money==2000?'active':''" @click="money=2000;">2000元</span> -->
          </div>
          <a href="javascript:void(0)" class="recharge3" @click="getPayParms" style="margin-left: 5%">确认充值</a>
          <div class="invoice">
            说明：支付成功后，可登录pc机构后台在【费用中心】开具电子发票。
          </div>
          <!-- <a href="javascript:void(0)" class="recharge3" @click="succees=true">确认充值</a> -->
        </van-tab>
        <van-tab title="坐席开通" class="plusOpening">
          <div style="margin-top: 30px">
            <i>账号:</i><i>{{ organizationInfo.organizationName }}</i>
          </div>
          <van-row style="margin-top: 15px">
            <van-col span="16">
              <div class="openNum">
                <i>开通数量:
                  <van-stepper class="num" v-model="value" input-width="50px" integer style="display: inline-block" @change="rachargeMoney" />
                </i>
              </div>
            </van-col>
            <van-col span="8"><span>(台)</span></van-col>
          </van-row>
          <div style="margin-top: 15px; display: inline-block">
            <i>开户费用:</i><i>
              {{this.value * this.organizationInfolist.accountOpenPrice }}元</i>({{ this.organizationInfolist.accountOpenPrice }}元/台)
          </div>
          <div style="margin-top: 15px">
            <i>首月月租:</i><i>{{ this.value * this.organizationInfolist.monthPrice }}元</i>({{
              this.organizationInfolist.monthPrice
            }}元/月/台)
          </div>
          <div style="margin-top: 15px"><i>充值金额:</i></div>
          <div class="recharge_input" style="width: 84%; margin-left: 30px">
            <label>￥</label>
            <input type="number" name="plusmoney" min="100" v-model="plusmoney" />
            <img src="../../assets/images/inputclear.png" @click="
                plusmoney = 0;
                active = 1;
              " />
          </div>
          <div class="recharge2">
            <span v-for="(item, index) in moneyList" :key="index" :class="plusmoney == item ? 'active' : ''" @click="plusmoney = item">{{ item }}元</span>
          </div>
          <div>
            <i>合计支付:<span class="total">{{
               this.value * this.organizationInfolist.accountOpenPrice + this.organizationInfolist.monthPrice * this.value +
                parseInt(this.plusmoney )
              }}</span><i style="color: red; margin: 5px">元</i></i>
          </div>
          <a href="javascript:void(0)" class="recharge3" @click="getPayParm" style="margin-left: 5%; margin-top: 10px">支付</a>
          <div class="invoice">
            说明：支付成功后，可登录pc机构后台在【费用中心】开具电子发票。
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <van-popup v-model="succees" position="top" style="width: 100%; height: 100%">
      <div style="padding: 0 0.4rem; text-align: center">
        <p>
          <img src="../../assets/images/124.png" style="
              width: 2.84rem;
              display: block;
              margin: 0.66rem auto 0.46rem auto;
            " />
        </p>
        <p style="font-size: 0.38rem; margin: 0.2rem 0 0.6rem 0">
          <strong>支付成功</strong>
        </p>
        <p style="font-size: 0.32rem; color: #777777; margin: 0.2rem 0">
          本次充值金额 <font color="#FF8400" v-text="money"></font>元
        </p>
        <p style="font-size: 0.32rem; color: #777777; margin: 0.2rem 0">
          当前账户余额
          <font>{{
            (organizationInfo.accountBalance + money * 100) / 100
          }}</font>元
        </p>
        <a href="javascript:void(0)" class="recharge3" @click="succees_ck" style="margin-top: 0.6rem">确认</a>
      </div>
    </van-popup>
  </div>
</template>
<script>
// require('@/wx.js');

import {
  toPayByJSapi,
  getOrganizationInfoByPhone,
  getOrganizationVersionInfoById,
  getIsFirstRecharge,
  getPayParam,
} from "../../api";
export default {
  name: "recharge",
  data() {
    return {
      organizationInfo: {
        accountBalance: 0,
      },
      organizationInfolist: {},
      openId: "",
      money: 100,
      sipmoney: 100,
      plusmoney: 100,
      phone: "",
      active: 0,
      show: false,
      actions: [],
      succees: false,
      wxConfig: {},
      onShow: true,
      // onShow: false,
      moneyList: [100, 200, 300, 500, 1000, 2000],
      billMoneyList: [100, 200, 300, 500, 1000, 2000],
      value: 0, // 开户数量
      cost: 99, // 开户费用
      monthly: 25, // 月租
      ifFirst: false,
    };
  },
  methods: {
    rachargeMoney() {
      if (this.ifFirst) {
        this.moneyList = [];
        for (var i = 1; i <= 6; i++) {
          this.moneyList.push(this.value * 100 * i);
        }
      }
    },
    getTab() {
      this.value = 1;
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return "";
    },
    succees_ck() {
      this.succees = false;
      this.money = "";
      this.sipmoney = "";
      this.plusmoney = 0;
      this.getOrganizationInfo();
    },
    getOrganizationVersionInfoByIdlist() {
      getOrganizationVersionInfoById("?organizationId=" + this.organizationInfo.id).then((res) => {
        if (res.code == 1) {
          this.organizationInfolist = res.data;
        } else {
          this.$toast("错误信息:" + res.message);
        }
      });
    },
    getIsFirstRecharge() {
      var that = this;
      getIsFirstRecharge({
        organizationId: that.organizationInfo.id,
      }).then((res) => {
        if (res.code == 1) {
          if (Number(res.data.isFirst) == 1) {
            that.ifFirst = true;
            that.moneyList = [];
            for (var i = 1; i <= 6; i++) {
              that.moneyList.push(100 * i);
            }
            if (Number(res.data.groupUserCount) > 0) {
              that.billMoneyList = [];
              for (var i = 1; i <= 6; i++) {
                that.billMoneyList.push(100 * res.data.groupUserCount * i);
              }
            }
          }
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
    },
    getOrganizationInfo() {
      var that = this;
      getOrganizationInfoByPhone("?phone=" + this.phone).then((res) => {
        if (res.code == 1) {
          that.organizationInfo = res.data;
          that.getOrganizationVersionInfoByIdlist();
          that.getIsFirstRecharge();
          that.onShow = false;
          that.getPayParam();
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
    },
    getPayParm() {
      var that = this;
      var money = parseInt(that.money * 100) / 100;
      var sipmoney = parseInt(that.sipmoney * 100) / 100;
      var plusmoney = parseInt(that.plusmoney * 100) / 100;
      that.money = money.toFixed(2);
      that.sipmoney = sipmoney.toFixed(2);
      that.plusmoney = plusmoney.toFixed(2);
      if (this.active == 0) {
        toPayByJSapi.payPurpose = 1;
        if (that.money == "" || that.money < that.billMoneyList[0]) {
          that.$toast("至少充值" + that.billMoneyList[0] + "元的金额！");
          return;
        }
      } else if (this.active == 1) {
        toPayByJSapi.payPurpose = 8;
        that.money = that.plusmoney;
        if (that.money == "") {
          that.money = 0;
        }
        if (!that.ifFirst) {
          if (that.money < 100 && that.money != 0) {
            that.$toast("至少充值话费100元！");
            return;
          }
        } else {
          if (that.money < 100 * that.value && that.money != 0) {
            that.$toast("至少充值话费" + 100 * that.value + "元！");
            return;
          }
        }
      } else if (this.active == 2) {
        toPayByJSapi.payPurpose = 7;
        that.money = that.sipmoney;
        if (that.money == "") {
          that.money = 0;
        }
        if (!that.ifFirst) {
          if (that.money < 100 && that.money != 0) {
            that.$toast("请至少充值话费100元！");
            return;
          }
        } else {
          if (that.money < 100 * that.value && that.money != 0) {
            that.$toast("请至少充值话费" + 100 * that.value + "元！");
            return;
          }
        }
      }
      if (
        that.openId == null ||
        that.openId == "" ||
        that.openId.indexOf("undefined") != -1
      ) {
        that.$toast("授权失效，请重新登录！");
        that.$router.push("/login");
        return;
      }

      toPayByJSapi({
        aiCount: this.value,
        day: 0,
        money: that.money * 100,
        organizationId: that.organizationInfo.id,
        payPurpose: toPayByJSapi.payPurpose,
        payType: 1,
        openId: that.openId,
      }).then(function (res) {
        if (res.code == 1) {
          that.wxConfig = res.data;
          that.initwxserver();
        } else {
          that.$toast(res.message);
        }
      });
    },
    getPayParms() {
      var that = this;
      var money = parseInt(that.money * 100) / 100;
      var sipmoney = parseInt(that.sipmoney * 100) / 100;
      var plusmoney = parseInt(that.plusmoney * 100) / 100;
      that.money = money.toFixed(2);
      that.sipmoney = sipmoney.toFixed(2);
      that.plusmoney = plusmoney.toFixed(2);
      if (this.active == 0) {
        toPayByJSapi.payPurpose = 1;
        if (that.money == "" || that.money < that.billMoneyList[0]) {
          that.$toast("至少充值" + that.billMoneyList[0] + "元的金额！");
          return;
        }
      } else if (this.active == 1) {
        toPayByJSapi.payPurpose = 8;
        that.money = that.plusmoney;
        if (that.money == "") {
          that.money = 0;
        }
        if (!that.ifFirst) {
          if (that.money < 100 && that.money != 0) {
            that.$toast("至少充值话费100元！");
            return;
          }
        } else {
          if (that.money < 100 * that.value && that.money != 0) {
            that.$toast("至少充值话费" + 100 * that.value + "元！");
            return;
          }
        }
      } else if (this.active == 2) {
        toPayByJSapi.payPurpose = 7;
        that.money = that.sipmoney;
        if (that.money == "") {
          that.money = 0;
        }
        if (!that.ifFirst) {
          if (that.money < 100 && that.money != 0) {
            that.$toast("请至少充值话费100元！");
            return;
          }
        } else {
          if (that.money < 100 * that.value && that.money != 0) {
            that.$toast("请至少充值话费" + 100 * that.value + "元！");
            return;
          }
        }
      }
      if (
        that.openId == null ||
        that.openId == "" ||
        that.openId.indexOf("undefined") != -1
      ) {
        that.$toast("授权失效，请重新登录！");
        that.$router.push("/login");
        return;
      }

      toPayByJSapi({
        aiCount: 0,
        day: 0,
        money: that.money * 100,
        organizationId: that.organizationInfo.id,
        payPurpose: toPayByJSapi.payPurpose,
        payType: 1,
        openId: that.openId,
      }).then(function (res) {
        if (res.code == 1) {
          that.wxConfig = res.data;
          that.initwxserver();
        } else {
          that.$toast(res.message);
        }
      });
    },
    initwxserver() {
      var that = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", bridgePay, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", bridgePay);
          document.attachEvent("onWeixinJSBridgeReady", bridgePay);
        }
      } else {
        that.bridgePay("getBrandWCPayRequest");
      }
    },
    bridgePay(serverName) {
      var that = this;
      WeixinJSBridge.invoke(serverName,
        {
          appId: that.wxConfig.appId,
          //公众号名称，由商户传入
          timeStamp: that.wxConfig.timeStamp,
          //时间戳，自1970年以来的秒数
          nonceStr: that.wxConfig.nonceStr,
          //随机串
          package: that.wxConfig.package,
          signType: that.wxConfig.signType,
          //微信签名方式：
          paySign: that.wxConfig.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            that.succees = true;
            that.$toast("支付成功!");
          }
        }
      );
    },
    onBlur() {
      var that = this;
      console.log(that.phone);
      if (!/^1[3456789]\d{9}$/.test(that.phone)) {
        that.$toast("手机号码错误!");
        return false;
      }
      that.getOrganizationInfo();
    },
    getPayParam() {
      getPayParam({}).then((res) => {
        if (res.code == 1) {
          this.cost = res.data.openAccountPrice;
          this.monthly = res.data.monthRentPrice;
        } else {
          this.$message.error("支付参数缺失，请联系客服！");
        }
      });
    },
  },
  mounted() {
    this.openId = sessionStorage.getItem("openId");
  },
};
</script>
<style type="text/css">
.recharge_head {
  width: 100%;
  height: 3.6rem;
  background-image: url(../../assets/images/123.png);
  background-size: 6.7rem 2.8rem;
  background-repeat: no-repeat;
  background-position: center;
  padding: 0.4rem;
  font-size: 0.28rem;
  line-height: 0.28rem;
  color: #fff;
}
.recharge_head p {
  margin: 0.15rem 0.4rem;
}
.recharge_body {
  padding: 0rem 0.4rem;
}
.recharge1 {
  color: #777777;
  font-size: 0.32rem;
}
.recharge_phone {
  font-size: 16px;
}
.recharge_input {
  width: 100%;
  height: 1.16rem;
  border-bottom: 1px solid #dedede;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #222222;
}
.recharge_input label {
  font-weight: bold;
  font-size: 0.52rem;
  width: 0.6rem;
}
.recharge_input input {
  font-weight: bold;
  font-size: 0.48rem;
  border: none;
  margin: 0 0.15rem;
  width: calc(100% - 0.6rem - 0.46rem - 0.3rem);
}
.recharge_input img {
  width: 0.46rem;
  height: 0.46rem;
}
.recharge2 {
  padding: 0.3rem 0.4rem;
  overflow: hidden;
}
.recharge2 span {
  width: 2rem;
  height: 1rem;
  display: block;
  float: left;
  margin: 0.1rem 0.1rem;
  line-height: 1rem;
  text-align: center;
  color: #222222;
  font-size: 0.32rem;
  font-weight: bold;
  border: 2px solid rgba(237, 237, 237, 1);
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0.12rem;
  background-color: #fff;
}
.recharge2 span.active {
  border: 2px solid rgba(59, 137, 255, 1);
  box-shadow: 0px 0px 24px 0px rgba(10, 65, 148, 0.17);
  color: #3b89ff;
  background-color: rgba(10, 65, 148, 0.05);
}
.recharge3 {
  background-color: #3b89ff;
  font-size: 0.32rem;
  color: #fff;
  text-align: center;
  line-height: 0.88rem;
  border-radius: 5px;
  height: 0.88rem;
  width: 90%;
  display: block;
  margin-top: 0;
}
p.recharge4 {
  color: #000;
  /*padding: .1rem;*/
  text-align: center;
  border-top: 1px solid #dedede;
  height: 1rem;
  line-height: 1rem;
  margin: 0;
  display: block;
  font-size: 0.32rem;
}
.plusOpening {
  font-size: 0.32rem;
}
.plusOpening i {
  margin-left: 30px;
}
/* .plusOpening div{
		margin-top: 30px;
	} */
.total {
  color: red;
  font-size: 0.4rem;
  margin-left: 20px;
}
.openNum {
  position: relative;
}
.num {
  position: absolute;
  top: -4px;
  left: 2.5rem;
}
.invoice {
  margin-left: 5%;
  font-size: 12px;
  margin-top: 10px;
  width: 90%;
  margin-bottom: 50px;
}
.van-stepper__plus {
  margin-left: 3px;
  border-radius: 5px;
  color: #ccc;
}
.van-stepper__input {
  margin-left: 3px;
  border-radius: 5px;
}
.van-stepper__minus {
  border-radius: 5px;
  color: #ccc;
}
.van-tab__pane {
  height: 100%;
  overflow: hidden;
}
.phonelogin {
  height: 100%;
  overflow: hidden;
}
.recharge_content {
  height: 100%;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/order/newRecharge.vue


// WEBPACK FOOTER //
// src/views/order/newRecharge.vue